import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const CLASS_SCHEDULES_CLASS_SCHEDULE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/class-schedules',
        iconClass: 'fas fa-calendar',
        name: '::Menu:ClassSchedules',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.ClassSchedules',
      },
    ]);
  };
}
